"use strict";

var curry = require("../Strict/curry.js");

var emptyL = require("./emptyL.js");

var mapL = require("./mapL.js");

var rangeL = require("./rangeL.js");

module.exports = curry(function splitEveryL(n, str) {
  if (!str) return emptyL();
  return mapL(i => str.substr(i * n, n), rangeL(Math.ceil(str.length / n)));
});